const ready = (callback) => {
  if (document.readyState !== 'loading') callback()
  else document.addEventListener('DOMContentLoaded', callback)
}

ready(() => {
  window.addEventListener('scroll', function () {
    checkStagePosition()
  })

  function checkStagePosition () {
    const stage = document.querySelector('.stage')
    const header = document.querySelector('.header')
    const maxTranslate = -5.59

    let top = stage.getBoundingClientRect().top
    let bottom = top + stage.clientHeight
    let scroll = window.pageYOffset
    let stageHeight = stage.getBoundingClientRect().height / 2

    if (header) {
      stageHeight = (stage.getBoundingClientRect().height + header.getBoundingClientRect().height) / 2
    }

    let percentage = scroll / stageHeight * 100

    if (bottom < 0) {
      stage.style.setProperty('--stage-translate', maxTranslate + '%')
    } else {
      stage.style.setProperty('--stage-translate', `${percentage * maxTranslate / 100}%`)
    }
  }
})
